import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text
import img1 from "../assets/images/item9/subitm1.jpg";
import img2 from "../assets/images/item9/subitm2.jpg";
import img3 from "../assets/images/item9/subitm3.jpg";
import img4 from "../assets/images/item9/subitm4.jpg";


const rowsData = [
  {
    id: 1,
    title: "Ball Bearings",
    text: "Smooth and durable ball bearings for efficient rotation and low friction.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Ball bearings reduce friction and allow smooth movement in rotating parts. Made from high-quality steel for long-lasting performance. Provide precise operation in automotive and industrial machinery.`
  },
  {
    id: 2,
    title: "Roller Bearings",
    text: "Heavy-duty roller bearings for supporting high loads and reducing friction.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `Roller bearings are designed to carry heavier radial and axial loads. Provide reliable support for rotating shafts and machinery. Made from strong, wear-resistant materials for long service life.`
  },
  {
    id: 3,
    title: "Motor & Pumps",
    text: "High-performance motors and pumps for efficient industrial operations.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `Industrial motors and pumps deliver reliable power and fluid transfer. Available in various capacities for different applications. Built for continuous operation with energy-efficient designs.
`
  },
  {
    id: 4,
    title: "High Pressure Hydraulic Tools",
    text: "Powerful high-pressure hydraulic tools for heavy-duty industrial tasks.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `High-pressure hydraulic tools provide strong force for demanding applications. Perfect for lifting, pressing, and clamping operations. Designed for precision, safety, and long-term reliability.`
  }
];

function Z9() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z9;